import { axios } from '@/lib/axios';
import { useMutation } from 'react-query';
import { MutationConfig } from '@/lib/react-query';

export type req = {
    id: number;
}

export const getClaimDetail = (
    { id }: req
): Promise<any> => {
    return axios.post(`/account/get-claim-detail/${id}`);
};


type UseOptionss = {
    config?: MutationConfig<typeof getClaimDetail>;
};

export const useGetClaimDetails = ({ config }: UseOptionss = {}) => {
    return useMutation({
        ...config,
        mutationFn: getClaimDetail,
    });
};
